import React from 'react';
import styles from './ChartTypeSelector.module.css';

export type ChartType = 'dietary' | 'health' | 'visit_types';

interface ChartTypeSelectorProps {
  selectedType: ChartType;
  onTypeChange: (type: ChartType) => void;
  label?: string;
  className?: string;
}

const ChartTypeSelector: React.FC<ChartTypeSelectorProps> = ({
  selectedType,
  onTypeChange,
  label = "Chart Type",
  className = ""
}) => {
  const chartTypeLabels = {
    dietary: 'Dietary Preferences',
    health: 'Health Concerns',
    visit_types: 'Visit Types'
  };


  const selectedLabel = chartTypeLabels[selectedType];

  return (
    <div className={`${styles.chartTypeSelector} ${className}`}>
      <div className={styles.selectorHeader}>
        <label className={styles.selectorLabel}>{label}</label>
        {selectedType && (
          <div className={styles.selectedTypeInfo}>
            <span className={styles.typeName}>{selectedLabel}</span>
          </div>
        )}
      </div>
      
      <div className={styles.selectorWrapper}>
        <select
          value={selectedType}
          onChange={(e) => onTypeChange(e.target.value as ChartType)}
          className={styles.typeSelect}
        >
          {Object.entries(chartTypeLabels).map(([value, label]) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
        <div className={styles.selectorIcon}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="6,9 12,15 18,9"></polyline>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default ChartTypeSelector;
